import React, { useState, useEffect } from 'react';
import { API_BASE } from '../App';

const MyInventory = ({ user, token, onBack, onNavigate }) => {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyInventory();
  }, []);

  const fetchMyInventory = async () => {
    try {
      const response = await fetch(`${API_BASE}/my-inventory`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const data = await response.json();
        setInventory(data);
      }
    } catch (error) {
      console.error('Envanter yüklenirken hata:', error);
    }
    setLoading(false);
  };

  const getStatusLabel = (status) => {
    const labels = {
      active: 'Aktif',
      assigned: 'Atanmış',
      maintenance: 'Bakımda',
      broken: 'Arızalı',
      procurement: 'Tedarik Sürecinde'
    };
    return labels[status] || status;
  };

  return (
    <div className="container">
      <button onClick={onBack} className="btn-back">Geri Dön</button>
      <div className="inventory-header">
        <h2>Envanter Listesi</h2>
        <button 
          onClick={() => onNavigate('create-fault-report')} 
          className="btn-primary"
        >
          🔧 Arıza Bildir
        </button>
      </div>
      
      {loading ? (
        <div className="loading">Yükleniyor...</div>
      ) : inventory.length === 0 ? (
        <div className="no-data">Size atanan hiç ürün bulunmuyor.</div>
      ) : (
        <div className="inventory-grid">
          {inventory.map(item => (
            <div key={item.id} className="inventory-card">
              <div className="inventory-header">
                <h3>{item.product_name}</h3>
                <span className={`inventory-status status-${item.status}`}>
                  {getStatusLabel(item.status)}
                </span>
              </div>
              <div className="inventory-details">
                <p><strong>Marka/Model:</strong> {item.brand} {item.model}</p>
                <p><strong>Seri No:</strong> {item.serial_code}</p>
                <p><strong>Ürün Kodu:</strong> {item.product_code}</p>
                <p><strong>Kategori:</strong> {item.category_name || 'Belirtilmemiş'}</p>
                {item.location && <p><strong>Konum:</strong> {item.location}</p>}
                <p><strong>Atanma Tarihi:</strong> {new Date(item.assignment_date || item.created_at).toLocaleDateString('tr-TR')}</p>
                {item.purchase_date && <p><strong>Alış Tarihi:</strong> {new Date(item.purchase_date).toLocaleDateString('tr-TR')}</p>}
                {item.warranty_end_date && <p><strong>Garanti Bitiş:</strong> {new Date(item.warranty_end_date).toLocaleDateString('tr-TR')}</p>}
                {item.notes && (
                  <p><strong>Notlar:</strong> {item.notes}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyInventory;